import DatabaseService from 'services/DatabaseService.js';
import {addCategories, addCategory} from 'actions/categories.js';
import {SET_CHALLENGES,
        SET_PINNED,
        REPLACE_CHALLENGE,
        ADD_CHALLENGE,
        ADD_CHALLENGES} from 'actions/types';
import {isChallengesListLoaded,
        isPinnedLoaded,
        getChallenges,
        getPinned,
        getChallenge}  from 'reducers/challenges.js';

//Action Creators
export const setChallenges = (challenges) => {
    return { type:SET_CHALLENGES, challenges:challenges};
}
export const setPinned = (pinned) => {
    return { type:SET_PINNED, pinned:pinned};
}
export const addChallenge = (challenge) => {
    return { type:ADD_CHALLENGE, challenge:challenge};
}
export const replaceChallenge= (oldChallenge, challenge) => {
    return { type:REPLACE_CHALLENGE, oldChallenge, challenge};
}
export const addChallenges = (challenges) => {
    return { type:ADD_CHALLENGES, challenges:challenges};
}


//helpers
export const processPinned = (dispatch, pinned) => {
    dispatch(addCategories(pinned.map(c=>c.category).filter(cat=>cat!=null)));
    dispatch(setPinned(pinned));
}

export const processChallenges = (dispatch, challenges) => {
    dispatch(addCategories(challenges.map(c=>c.category).filter(cat=>cat!=null)));
    dispatch(setChallenges(challenges));
}

export const processSeasonChallenges = (dispatch, challenges) => {
    dispatch(addCategories(challenges.map(c=>c.category).filter(cat=>cat!=null)));
    dispatch(addChallenges(challenges));
}


//Thunks
export const fetchChallenges = (force) => (dispatch, getState) => {
    if(!force) {
        var state = getState();
        if(isChallengesListLoaded(state.challenges)) {
            return Promise.resolve(getChallenges(state.challenges));
        }
    }

    return new Promise(function(resolve, reject) {
        DatabaseService.getTimeline({challenges:true}).then( //timeline
            function(result) {
                console.log('fetchChallenges', result);
                var challenges = result.challenges;
                processChallenges(dispatch, challenges);
                resolve(challenges); 
            },
            function(error) {
                console.error(error);
                reject(error); 
            });
    });
}
export const fetchPinned = (force) => (dispatch, getState) => {
    if(!force) {
        var state = getState();
        if(isPinnedLoaded(state.challenges)) {
            return Promise.resolve(getPinned(state.challenges));
        }
    }

    return new Promise(function(resolve, reject) {
        DatabaseService.getTimeline({pinned:true}).then( //timeline
            function(result) {
                console.log('fetchPinned', result);
                var pinned = result.pinned;
                processPinned(dispatch, pinned);
                resolve(pinned); 
            },
            function(error) {
                console.error(error);
                reject(error); 
            });
    });
}
export const fetchChallenge = (id, force) => (dispatch, getState) => {
    if(!force) {
        var challenge = getChallenge(getState().challenges, id);
        if(challenge) {
            return Promise.resolve(challenge);
        }
    }
    
    return new Promise(function(resolve, reject) {
        DatabaseService.fetchChallenge(id).then(
            function(result){ 
                var challenge = result.challenge;
                var category = challenge.category;
                if(category) {
                    dispatch(addCategory(category));
                }
                dispatch(addChallenge(challenge));
                resolve(challenge);
            },
            function(error){ 
                console.error(error);
                reject(error); 
            });
    });
}

export const skipChallenge = (challengeId, forward) => (dispatch, getState) => {
    var challenge = getChallenge(getState().challenges, challengeId);
    return new Promise(function(resolve, reject) {
        DatabaseService.skipChallenge(challengeId, forward).then(
            function(result){ 
                console.log("skipChallenge result: ", result);
                var newChallenge = result.challenge;
                var category = newChallenge.category;
                if(category) {
                    dispatch(addCategory(category));
                }
                dispatch(replaceChallenge(challenge, newChallenge));
                resolve(newChallenge);
            },
            function(error){ 
                console.error(error);
                reject(error); 
            });
    });
}



// WEBPACK FOOTER //
// ./src/actions/challenges.js